import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from '@denishussar/html5-game-engine';
import { GameModel } from '../../Models/Game/GameModel';
import { GameLogic } from '../../Logic/GameLogic';
import { ModelEvents } from '@denishussar/html5-game-engine/dist';
import { AnimationContents } from '../../../AnimationContents';

export class UITooltipController extends AnimationBaseController {
    $model: GameModel;

    public constructor(@Inject private _options,
                       @Inject private _gameLogic: GameLogic,
    ) {
        super('UITooltipController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            animationContent: AnimationContents.TOOLTIP_JSON,
            libraryName: 'tooltips',
            childControllers: {
                // TooltipAchievement: {
                //   instanceName: "tooltip_achievement",
                //   view: UITooltipListController,
                //   model: this.$model,
                // },
            },
            onTap: () => {
                this._gameLogic.hideTooltip();
            },
        };
    }

    protected onInitialize(): void {
        this._changeTooltip();
    }

    private _changeTooltip() {
        this.gotoAndStop(this.$model.tooltipState);
        this.setTextByQuery('text', this.$model.tooltipText);

        if (this.$model.tooltipState === 'achievement') {
            this.gotoAndStopByQuery(
                `tooltip_${this.$model.tooltipState}.icons_${this.$model.tooltipState}`,
                `${this.$model.tooltipIcon.toLowerCase()}`,
            );
        }
    }

    protected onResize(width: number, height: number, scale: number): void {
        this.x = width / scale / 40;
        this.y = height / scale - 180;
    }
}

export class UITooltipListController extends AnimationBaseController {
    $model: GameModel;

    public constructor(
        @Inject private _options,
        @Inject private _gameLogic: GameLogic,
        @Inject private _modelEvents: ModelEvents,
    ) {
        super('UITooltipListController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            modelWatch: {},
        };
    }

    protected onInitialize(): void {
        this.gotoAndStopByQuery(
            'icons_achievement',
            `${this.$model.tooltipIcon}`,
        );
    }

    protected onResize(width: number, height: number, scale: number): void {
        this.x = -width / scale / 2;
        this.y = -height / scale / 2;
        this.display.scale.set(2 / scale);
    }
}
